import { Image } from '@change/ds-core-ui';
import { Grid } from '@change/ds-layout';

import { PageHeaderTitle } from './components/PageHeaderTitle';
import { PageHeaderToolbar } from './components/PageHeaderToolbar';
import { usePageHeader } from './hooks/usePageHeader';
import { container as containerStyles, header as headerStyles } from './PageHeader.styles';

export function PageHeader(): JSX.Element {
	const {
		data: { mobile, orientation, actionButtons, buttonVariant, imageUrl, title },
	} = usePageHeader();

	const headerStyle = headerStyles({ isMobile: mobile, orientation });
	const containerStyle = containerStyles({ isMobile: mobile, orientation });

	return (
		<section className="border-stroke-weaker bg-background-base z-20 w-full border-b md:sticky md:top-0 md:right-0 md:left-0">
			<Grid className="px-0! py-0!">
				<header className={headerStyle} aria-label="Starter Dashboard page header" data-testid="page-header">
					<div data-testid="page-header-container" className={containerStyle}>
						<PageHeaderTitle
							image={
								imageUrl && (
									<Image
										alt={title}
										data-testid="starter-dashboard-header-image"
										data-qa="starter-dashboard-header-image"
										src={imageUrl}
										className="rounded-medium flex aspect-square h-[40px] w-[40px] shrink-0 items-center justify-center gap-3.5 object-cover"
									/>
								)
							}
							title={title}
						/>
						{actionButtons.length > 0 && (
							<PageHeaderToolbar actionButtons={actionButtons} mobile={mobile} buttonVariant={buttonVariant} />
						)}
					</div>
				</header>
			</Grid>
		</section>
	);
}
